(() => {
  const collectionLayout = document.querySelector('.qva-single-facets');
  const drawer = collectionLayout?.querySelector('menu-drawer.mobile-facets__wrapper');
  const rootDetails = drawer?.querySelector(':scope > details');
  if (!rootDetails || drawer.dataset.qvaResponsiveReady) return;
  drawer.dataset.qvaResponsiveReady = 'true';

  const desktopQuery = window.matchMedia('(min-width: 750px)');
  let desktopGroups;

  const syncExpandedStates = () => {
    drawer.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      const expanded = details.open ? 'true' : 'false';
      if (summary?.getAttribute('aria-expanded') !== expanded) summary?.setAttribute('aria-expanded', expanded);
    });
  };

  const setMode = () => {
    const desktop = desktopQuery.matches;
    const mode = desktop ? 'desktop' : 'mobile';
    if (drawer.qvaFacetMode === mode) return;
    const groups = Array.from(drawer.querySelectorAll('details.mobile-facets__details'));
    const active = document.activeElement;
    const hadFilterFocus = drawer.contains(active) || active?.id === 'SortBy';
    const wasMobileOpen = drawer.qvaFacetMode === 'mobile' && rootDetails.open;

    if (drawer.qvaFacetMode === 'desktop') desktopGroups = new Set(groups.filter((group) => group.open).map((group) => group.id));
    // Invalidate delayed native drawer animations before changing its layout.
    drawer.qvaFacetModeVersion = (drawer.qvaFacetModeVersion || 0) + 1;
    drawer.qvaFacetMode = mode;
    if (wasMobileOpen) {
      document.body.classList.remove(`overflow-hidden-${drawer.dataset.breakpoint}`);
      removeTrapFocus();
    }

    drawer.querySelectorAll('.menu-opening, .submenu-open').forEach((element) => {
      element.classList.remove('menu-opening', 'submenu-open');
    });
    document.documentElement.classList.toggle('qva-single-facets-desktop', desktop);
    drawer.classList.toggle('qva-single-facets__static', desktop);
    rootDetails.classList.toggle('qva-single-facets__root', desktop);
    rootDetails.open = desktop;

    const initialGroup = groups.find((group) => group.querySelector('input:checked')) || groups[0];
    groups.forEach((group) => {
      group.open = desktop && (desktopGroups ? desktopGroups.has(group.id) : group === initialGroup);
    });
    syncExpandedStates();

    // Do not leave keyboard focus inside a newly hidden drawer/control.
    if (hadFilterFocus) {
      const target = desktop
        ? (active?.name === 'sort_by' ? collectionLayout.querySelector('#SortBy') : (groups.find((group) => group.open) || groups[0])?.querySelector('summary'))
        : rootDetails.querySelector(':scope > summary');
      target?.focus({ preventScroll: true });
    }
  };

  // Both sort controls represent the same state, including during debounce.
  collectionLayout.addEventListener('input', (event) => {
    if (event.target.name !== 'sort_by') return;
    collectionLayout.querySelectorAll('select[name="sort_by"]').forEach((select) => { select.value = event.target.value; });
  });
  drawer.addEventListener('toggle', syncExpandedStates, true);
  // Section updates replace summaries inside retained open filter groups.
  new MutationObserver(syncExpandedStates).observe(drawer, { childList: true, subtree: true });
  desktopQuery.addEventListener('change', setMode);
  setMode();
})();
